"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  vscLog: {
    shipSynchronization: 'Ship Sync',
    shipCommunication: 'Ship Communication',
    vesselId: 'Vessel',
    commStatus: 'Vessel Status',
    pleaseSelect: 'please select',
    vesselCnName: 'Vessel Name',
    email: 'Mail',
    operation: 'Operation',
    dataEmail: 'Data Email',
    passwd2: 'Data retransmission',
    email2: 'Resend attachment',
    pleaseEnter: 'Please enter',
    passwd: 'Password',
    haveImplemented: 'Implemented',
    unimplemented: 'Unimplemented',
    notEmpty: 'Can not be blank',
    selectStatus: 'Please select status',
    shipExisting: 'The ship already exists!',
    searchFailed: 'Search failure',
    saveSuccessfully: 'Save Successfully',
    updateSuccessfully: 'Update Successfully',
    deleteData: 'Are you sure to delete this item',
    reminder: ' Reminder',
    yes: 'Yes',
    no: 'No',
    successfullyDelete: 'Successfully delete',
    synchronousTable: 'Sync Table',
    tableName: 'Table Name',
    pleaseEnterContent: 'Please enter content',
    modelName: 'Model Name',
    syncFlag: 'Issync',
    syncByCompanyFlag: 'Sync By Company Flag',
    tableN: 'Table Name',
    tableChineseName: 'Table Nmae(CN)',
    modelN: 'Object Name',
    modelParser: 'Object Resolver',
    syncVesselField: 'Shipping Field',
    packageClassName: 'package&Class Name',
    syncVesselCondition: 'Shore Side Conditions',
    elExpression: 'Elexpression',
    elExpressionVessel: 'elExpression Vessel',
    syncShoreCondition: 'Ship Side Conditions',
    syncVesselSql: 'Synchronous Ship SQL',
    alreadyExist: 'Table name or object name already exists!',
    synchronousFile: 'Sync  File',
    vesselCode: 'Vessel Code',
    fileName: 'Attachment Names',
    logType: 'Log Type',
    logFileStatus: 'Executing State',
    sendLogDtmFrom: 'Date of Sending Data',
    selectDate: 'Select Date',
    sendLogDtmTo: 'Sendlogdtm to',
    receiveLogDtmFrom: 'Date of Receipt',
    serialNo: 'Mail Serial Number',
    entityName: 'Entity Name',
    ddlType: 'DDL Type',
    entityId: 'Entity Id',
    entityData: 'Entity Data',
    sendData: 'Send Data',
    fileSize: 'File Size',
    entityType: 'Entity Type',
    sendFlag: 'Whether to Send',
    sendLog: 'Send Log',
    receivingLog: 'Receiving Log',
    resendLog: 'Resend Log',
    nonExecution: 'Non Execution',
    sentEmails: 'Sended',
    synchronousSuccess: 'Sync Success',
    synchronizationFailure: 'Sync Failure',
    watch: 'Table',
    object: 'Object',
    newlyIncreased: 'Add',
    unsent: 'Unsend',
    delete: 'Delete',
    revamp: 'Update',
    defeated: 'Failure',
    advanceTo: 'Success',
    synchronousAttachment: 'Sync Attachment',
    attachmentName: 'Attachment Names',
    attachmentSize: 'Attachment Size',
    createTime: 'Send Time',
    xeecuteSuccessfully: 'Ecute Successfully',
    filter: 'Filter',
    keyword: 'File Name',
    packetRetransmission: 'Packet Resend',
    attachmentFileId: 'Attachment ID',
    referenceId: 'Primary Key Business',
    referenceTable: 'Business Name of the Table',
    selectToSend: 'Please select a record to send',
    sendSuccessfully: 'send successfully',
    waitingSent: 'The packet is waiting to be sent',
    sendLogDtm: 'Date of sending data',
    receiveLogDtm: 'Date of receipt',
    errorMessage: 'Error Log',
    resendSuccess: 'Resend success',
    executedSuccessfully: 'The data was executed successfully',
    vesselName: 'Vessel Name',
    isUpdated: 'Isupdated',
    all: 'All',
    unDone: 'Unupdate',
    updateSuccess: 'Update Success',
    updateFail: 'Update Fail',
    vesselUpdate: 'Vessel Update',
    syncData: 'Sync Data',
    syncVessel: 'Sync Vessel',
    syncShore: 'Sync Shore',
    reExecute: 'Re Execute',
    executeSuccess: 'execute success',
    executeFail: 'execute fail',
    selectToReExecute: 'Please select one to execute again',
    reExecutePrompt: 'You must select a record of execution failure',
    lastModifyTime: 'Last Modify Time'
  }
};